module.exports = __webpack_public_path__ + "static/media/support_white.a6fc8da2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/support_white.svg
// module id = 2231
// module chunks = 0